import React, { useRef, useState, useEffect, useContext } from "react";
import { moveElement, fadeIn, fadeOut } from "../../utils/elementUtils";
import ThemeContext from "../../context/ThemeContext";
import "./contact-me.css";

import exitLight from "../../assets/images/exitLight.png";
import exitDark from "../../assets/images/exit.png";

import mail1 from "../../assets/images/communication.png";
import mail2 from "../../assets/images/email.png";
import mail3 from "../../assets/images/gmail.png";
import { LogEvent } from "../../utils/EventLogging";

function ContactMe(props) {
  const { theme, setTheme } = useContext(ThemeContext);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (props.show) {
      LogEvent("show contact form");
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [props.show]);

  function Hide() {
    setIsActive(false);
    if (props.onHide) {
      setTimeout(() => props.onHide(), 400); // Allow CSS animation to finish
    }
  }

  function showLoader() {
    let loaderbg = document.querySelector("#contact-loader-bg");
    loaderbg.style.display = "flex";
  }

  function hideLoader() {
    let loaderbg = document.querySelector("#contact-loader-bg");
    loaderbg.style.display = "none";
  }

  async function Submit() {
    LogEvent("submit contact form");
    let subject = document.querySelector("#subject-input").value;
    let name = document.querySelector("#name-input").value;
    let email = document.querySelector("#email-input").value;
    let message = document.querySelector("#message-input").value;

    let v1 = validateSubject();
    let v2 = validateName();
    let v3 = validateEmail(email);
    let v4 = validateMessage();

    if (v1 && v2 && v3 && v4) {
      // Encode values for URL
      const encodedSubject = encodeURIComponent(subject);
      const bodyStr = `From: ${name} (${email})\n\n${message}`;
      const encodedBody = encodeURIComponent(bodyStr);

      // Native mailto link
      window.location.href = `mailto:sean@seanbrill.com?subject=${encodedSubject}&body=${encodedBody}`;

      Hide();
    }
  }

  const invalidClass = "invalid";

  function validateSubject() {
    let isValid = true;
    let subjectInput = document.querySelector("#subject-input");
    if (subjectInput.value.trim().length <= 1) {
      isValid = false;
      subjectInput.value = "";
      subjectInput.placeholder = "Subject Required";
      subjectInput.classList.add(invalidClass);
    } else {
      subjectInput.classList.remove(invalidClass);
    }
    return isValid;
  }

  function validateName() {
    let isValid = true;
    let nameInput = document.querySelector("#name-input");
    if (nameInput.value.trim().length <= 1) {
      isValid = false;
      nameInput.value = "";
      nameInput.placeholder = "Name Required";
      nameInput.classList.add(invalidClass);
    } else {
      nameInput.classList.remove(invalidClass);
    }
    return isValid;
  }

  function validateEmail(email) {
    let isValid = true;
    let emailInput = document.querySelector("#email-input");

    // Standard email regex
    const re = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/;

    if (!re.test(email.trim())) {
      isValid = false;
      emailInput.value = "";
      emailInput.placeholder = "Valid Email Required";
      emailInput.classList.add(invalidClass);
    } else {
      emailInput.classList.remove(invalidClass);
    }
    return isValid;
  }

  function validateMessage() {
    let isValid = true;
    let messageInput = document.querySelector("#message-input");
    if (messageInput.value.trim().length <= 1) {
      isValid = false;
      messageInput.value = "";
      messageInput.placeholder = "Message Required";
      messageInput.classList.add(invalidClass);
    } else {
      messageInput.classList.remove(invalidClass);
    }
    return isValid;
  }

  return (
    <>
      {/* POST Loader */}
      <div id="contact-loader-bg">
        <div id="contact-loader"></div>
      </div>
      <section id="contact-me-popup" className={isActive ? "show" : ""}>
        {/* Mail image */}
        <div className="contact-me-header">
          <img className="mail-icon" src={mail3} alt="mail icon" />
          <h3 className="contact-header-text">Send Me a Message</h3>
          <button className="contact-exit-button" onClick={Hide}>
            <img src={theme === "light" ? exitDark : exitLight} alt="exit icon" />
          </button>
        </div>
        <input id="subject-input" className="contact-field" type="text" placeholder="Subject" />
        <input id="name-input" className="contact-field" type="text" placeholder="Your Name" />
        <input id="email-input" className="contact-field" type="email" placeholder="Your Email" />
        <textarea id="message-input" className="contact-message" name="message" placeholder="Message" cols="30" rows="10" resize="none"></textarea>
        <button className="send-email-button" onClick={Submit}>
          Send Message!
        </button>
      </section>
    </>
  );
}

export default ContactMe;
